/** Onde o painel começa. */
import { createRoot } from 'react-dom/client'
import { StrictMode } from 'react'
import { App } from './App'
import { NOME_DO_SISTEMA } from './identidade'

/*
 * O nome da aba. O servidor já põe o nome no `<title>` da página que ele entrega, e isto é para
 * o servidor de desenvolvimento do Vite, que entrega o `index.html` sem passar por ele. Uma
 * fonte só para o nome, dos dois lados.
 */
document.title = NOME_DO_SISTEMA

/*
 * O painel instalável no celular: o service worker é o que faz o Chrome do Android oferecer
 * "Instalar aplicativo". Ele não guarda nada (ver `public/sw.js`). Fora da impressão: a página
 * que o fotógrafo do PDF abre não é para instalar.
 */
if ('serviceWorker' in navigator && !new URLSearchParams(window.location.search).has('impressao')) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // Sem service worker o painel funciona igual; só não se oferece para instalar.
    })
  })
}

const raiz = document.getElementById('raiz')
if (!raiz) throw new Error('a página não tem onde o painel entrar')

createRoot(raiz).render(
  <StrictMode>
    <App />
  </StrictMode>
)
